






import {Component}    from 'vue-property-decorator';
import {mixins}       from 'vue-class-component';
import * as zenscroll from 'zenscroll';
import MainMixin      from '@/mixins/Main';

@Component({
    name: `ScrollbarContainer`
})
export default class ScrollbarContainer extends mixins(MainMixin)
{
    public scrollMaxGet(): number
    {
        const {clientHeight, scrollHeight} = this.$el;

        return scrollHeight - clientHeight;
    }

    public scrollOn(): void
    {
        this.$emit(`scroll`, this.$el.scrollTop);
    }

    public scroller!: typeof zenscroll;

    public mounted(): void
    {
        this.scroller = this.$scroll.createScroller(this.$el as HTMLElement, 1000, 30);

        this.$el.addEventListener(`scroll`, this.scrollOn);
    }

    public destroyed(): void
    {
        this.$el.removeEventListener(`scroll`, this.scrollOn);
    }
}
